// Banner image revealed on scroll through an animated clip-path (GSAP): it starts clipped to its center and opens as the section crosses the viewport; GSAP and ScrollTrigger load on demand, once, and only if a banner enables the animation.
(function () {
  var GSAP_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js";
  var ST_SRC = "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js";

  var prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Sous 750px, une bannière marquée data-banner-reveal-desktop-only n'anime
  // pas : on affiche l'image de base (le CSS retire aussi le clip).
  var isMobile = window.matchMedia && window.matchMedia("(max-width: 750px)").matches;

  function isDesktopOnlyOnMobile(wrapper) {
    return isMobile && wrapper.hasAttribute("data-banner-reveal-desktop-only");
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      // Évite de recharger un script déjà présent.
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === "true") return resolve();
        existing.addEventListener("load", function () {
          resolve();
        });
        existing.addEventListener("error", reject);
        return;
      }
      var s = document.createElement("script");
      s.src = src;
      s.async = true;
      s.addEventListener("load", function () {
        s.dataset.loaded = "true";
        resolve();
      });
      s.addEventListener("error", reject);
      document.head.appendChild(s);
    });
  }

  function loadGsap() {
    if (window.gsap && window.ScrollTrigger) return Promise.resolve();
    return loadScript(GSAP_SRC).then(function () {
      return loadScript(ST_SRC);
    });
  }

  // Révèle immédiatement tous les médias (fallback / reduced-motion).
  function unclipMedia(wrapper) {
    wrapper.querySelectorAll(".banner_image").forEach(function (media) {
      media.style.clipPath = "none";
    });
  }

  function initReveal(wrapper) {
    if (wrapper.dataset.bannerRevealBound === "true") return;
    wrapper.dataset.bannerRevealBound = "true";

    // Une bannière peut contenir un média desktop et un média mobile : on les
    // anime tous les deux pour ne jamais laisser un média figé sur son clip.
    var images = wrapper.querySelectorAll(".banner_image");
    if (!images.length) return;

    var gsap = window.gsap;
    gsap.registerPlugin(window.ScrollTrigger);

    var inset = wrapper.getAttribute("data-banner-reveal-inset") || "25%";

    // The whole banner (image and content) is pinned to keep it centered while the reveal plays, the scroll feeding the scrub.
    var pinTarget = wrapper.closest(".banner_wrapper") || wrapper;

    // Distance de scroll consommée par l'animation (1 = une hauteur d'écran).
    // Valeur fixe (auparavant réglable via le paramètre scroll_reveal_distance).
    var distance = 1;

    gsap.fromTo(
      images,
      { clipPath: "inset(" + inset + ")", webkitClipPath: "inset(" + inset + ")" },
      {
        clipPath: "inset(0%)",
        webkitClipPath: "inset(0%)",
        ease: "none",
        scrollTrigger: {
          trigger: pinTarget,
          start: "center center",
          end: function () {
            return "+=" + Math.round(window.innerHeight * distance);
          },
          scrub: true,
          pin: pinTarget,
          pinSpacing: true,
          anticipatePin: 1,
          invalidateOnRefresh: true,
        },
      },
    );
  }

  function run(wrappers) {
    if (!wrappers.length) return;

    // Respecte la préférence "réduire les animations" : on révèle tout
    // immédiatement, sans charger GSAP.
    if (prefersReducedMotion) {
      Array.prototype.forEach.call(wrappers, unclipMedia);
      return;
    }

    // Sépare les bannières à animer de celles laissées à l'image de base sur
    // mobile (option « Désactiver l'animation sur mobile »).
    var toAnimate = [];
    Array.prototype.forEach.call(wrappers, function (wrapper) {
      if (isDesktopOnlyOnMobile(wrapper)) {
        unclipMedia(wrapper);
      } else {
        toAnimate.push(wrapper);
      }
    });

    if (!toAnimate.length) return;

    loadGsap()
      .then(function () {
        toAnimate.forEach(initReveal);
      })
      .catch(function () {
        // En cas d'échec du chargement de GSAP, on affiche le média entier
        // pour ne jamais laisser une bannière coupée.
        toAnimate.forEach(unclipMedia);
      });
  }

  function init() {
    run(document.querySelectorAll("[data-banner-reveal]"));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Réinitialisation dans l'éditeur de thème Shopify lors d'un rechargement
  // de section.
  document.addEventListener("shopify:section:load", function (event) {
    run(event.target.querySelectorAll("[data-banner-reveal]"));
  });
})();
